import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetSubscriptionPlansDto } from '@/types/dtos/transactions/response/get-subscription-plans.dto';

/** Query key prefix; `invalidateQueries({ queryKey: [ADMIN_SUBSCRIPTION_PLANS_QUERY_KEY] })` matches all `[ADMIN_SUBSCRIPTION_PLANS_QUERY_KEY, entityType]` variants (default prefix match). */
export const ADMIN_SUBSCRIPTION_PLANS_QUERY_KEY = 'admin-subscription-plans';

export function useAdminSubscriptionPlansQuery(entityType?: '' | 'Organization' | 'Event') {
  const { getToken } = useAuth();
  const et = entityType ?? '';

  return useQuery({
    queryKey: [ADMIN_SUBSCRIPTION_PLANS_QUERY_KEY, et],
    queryFn: async () => {
      const token = await getToken();
      const url = new URL(`${import.meta.env.VITE_API_URL}/transactions/admin/subscription-plans`);
      if (et) {
        url.searchParams.set('entityType', et);
      }
      return sendJSONRequest({
        url: url.toString(),
        method: METHOD.GET,
        token: token ?? '',
      }) as Promise<GetSubscriptionPlansDto>;
    },
  });
}
